module.exports = __webpack_public_path__ + "ed29310017a8f3185d55c3dc712b02c0.MP3";